import React from "react";
import { Link } from "react-router-dom";
import HeaderLogo from "../../assets/Sun Image (SKD).svg";
import { List, X } from "@phosphor-icons/react";

const Header = () => {
  return (
    <>
      <>
        <header id="qodef-page-header" role="banner">
          <div id="qodef-page-header-inner" className="">
            <div className="qodef-divided-header-left-wrapper">
              <nav
                className="qodef-header-navigation"
                role="navigation"
                aria-label="Divided Left Menu"
              >
                <ul id="menu-left-divided-menu" className="menu">
                  <li id="menu-item-3063">
                    <Link to={"/"}>
                      <span className="qodef-menu-item-text">
                        Home
                        <svg
                          className="qodef-menu-item-arrow"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="7.76px"
                          height="11.75px"
                          viewBox="0 0 7.76 11.75"
                          enableBackground="new 0 0 7.76 11.75"
                          xmlSpace="preserve"
                        >
                          <path
                            fill="#63605A"
                            d="M1.618,1.341l0.195-0.196l4.621,4.586v0.403l-4.621,4.586l-0.404-0.405l4.383-4.383L1.408,1.55L1.618,1.341z"
                          />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li id="menu-item-3064">
                    <Link to={"/about-us"}>
                      <span className="qodef-menu-item-text">
                        About Us
                        <svg
                          className="qodef-menu-item-arrow"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="7.76px"
                          height="11.75px"
                          viewBox="0 0 7.76 11.75"
                          enableBackground="new 0 0 7.76 11.75"
                          xmlSpace="preserve"
                        >
                          <path
                            fill="#63605A"
                            d="M1.618,1.341l0.195-0.196l4.621,4.586v0.403l-4.621,4.586l-0.404-0.405l4.383-4.383L1.408,1.55L1.618,1.341z"
                          />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li id="menu-item-3065">
                    <Link to={"/products"}>
                      <span className="qodef-menu-item-text">
                        Products
                        <svg
                          className="qodef-menu-item-arrow"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="7.76px"
                          height="11.75px"
                          viewBox="0 0 7.76 11.75"
                          enableBackground="new 0 0 7.76 11.75"
                          xmlSpace="preserve"
                        >
                          <path
                            fill="#63605A"
                            d="M1.618,1.341l0.195-0.196l4.621,4.586v0.403l-4.621,4.586l-0.404-0.405l4.383-4.383L1.408,1.55L1.618,1.341z"
                          />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li id="menu-item-3068">
                    <Link to={"/contact-us"}>
                      <span className="qodef-menu-item-text">
                        Contact Us
                        <svg
                          className="qodef-menu-item-arrow"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="7.76px"
                          height="11.75px"
                          viewBox="0 0 7.76 11.75"
                          enableBackground="new 0 0 7.76 11.75"
                          xmlSpace="preserve"
                        >
                          <path
                            fill="#63605A"
                            d="M1.618,1.341l0.195-0.196l4.621,4.586v0.403l-4.621,4.586l-0.404-0.405l4.383-4.383L1.408,1.55L1.618,1.341z"
                          />
                        </svg>
                      </span>
                    </Link>
                  </li>
                  <li id="menu-item-3065">
                    <Link to={"/track-order"}>
                      <span className="qodef-menu-item-text">
                        Track Order
                        <svg
                          className="qodef-menu-item-arrow"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlnsXlink="http://www.w3.org/1999/xlink"
                          x="0px"
                          y="0px"
                          width="7.76px"
                          height="11.75px"
                          viewBox="0 0 7.76 11.75"
                          enableBackground="new 0 0 7.76 11.75"
                          xmlSpace="preserve"
                        >
                          <path
                            fill="#63605A"
                            d="M1.618,1.341l0.195-0.196l4.621,4.586v0.403l-4.621,4.586l-0.404-0.405l4.383-4.383L1.408,1.55L1.618,1.341z"
                          />
                        </svg>
                      </span>
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
            <a
              itemProp="url"
              className="qodef-header-logo-link qodef-height--set"
              href="/#"
              style={{ height: 92 }}
              rel="home"
            >
              <img
                width={250}
                height={124}
                src={HeaderLogo}
                className="qodef-header-logo-image qodef--main"
                alt="logo main"
                itemProp="image"
              />
              <img
                width={250}
                height={124}
                src={HeaderLogo}
                className="qodef-header-logo-image qodef--dark"
                alt="logo dark"
                itemProp="image"
              />
              <img
                width={250}
                height={124}
                src={HeaderLogo}
                className="qodef-header-logo-image qodef--light"
                alt="logo light"
                itemProp="image"
              />
            </a>
          </div>
          <div className="qodef-header-sticky">
            <div className="qodef-header-sticky-inner">
              <div className="qodef-divided-header-left-wrapper">
                <nav
                  className="qodef-header-navigation"
                  role="navigation"
                  aria-label="Divided Left Menu"
                >
                  <ul id="menu-left-divided-menu-1" className="menu">
                    <li id="menu-item-3063">
                      <Link to={"/"}>
                        <span className="qodef-menu-item-text">
                          Home
                          <svg
                            className="qodef-menu-item-arrow"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="7.76px"
                            height="11.75px"
                            viewBox="0 0 7.76 11.75"
                            enableBackground="new 0 0 7.76 11.75"
                            xmlSpace="preserve"
                          >
                            <path
                              fill="#63605A"
                              d="M1.618,1.341l0.195-0.196l4.621,4.586v0.403l-4.621,4.586l-0.404-0.405l4.383-4.383L1.408,1.55L1.618,1.341z"
                            />
                          </svg>
                        </span>
                      </Link>
                    </li>
                    <li id="menu-item-3064">
                      <Link to={"/about-us"}>
                        <span className="qodef-menu-item-text">
                          About Us
                          <svg
                            className="qodef-menu-item-arrow"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="7.76px"
                            height="11.75px"
                            viewBox="0 0 7.76 11.75"
                            enableBackground="new 0 0 7.76 11.75"
                            xmlSpace="preserve"
                          >
                            <path
                              fill="#63605A"
                              d="M1.618,1.341l0.195-0.196l4.621,4.586v0.403l-4.621,4.586l-0.404-0.405l4.383-4.383L1.408,1.55L1.618,1.341z"
                            />
                          </svg>
                        </span>
                      </Link>
                    </li>
                    <li id="menu-item-3065">
                      <Link to={"/products"}>
                        <span className="qodef-menu-item-text">
                          Products
                          <svg
                            className="qodef-menu-item-arrow"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="7.76px"
                            height="11.75px"
                            viewBox="0 0 7.76 11.75"
                            enableBackground="new 0 0 7.76 11.75"
                            xmlSpace="preserve"
                          >
                            <path
                              fill="#63605A"
                              d="M1.618,1.341l0.195-0.196l4.621,4.586v0.403l-4.621,4.586l-0.404-0.405l4.383-4.383L1.408,1.55L1.618,1.341z"
                            />
                          </svg>
                        </span>
                      </Link>
                    </li>
                    <li id="menu-item-3068">
                      <Link to={"/contact-us"}>
                        <span className="qodef-menu-item-text">
                          Contact Us
                          <svg
                            className="qodef-menu-item-arrow"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="7.76px"
                            height="11.75px"
                            viewBox="0 0 7.76 11.75"
                            enableBackground="new 0 0 7.76 11.75"
                            xmlSpace="preserve"
                          >
                            <path
                              fill="#63605A"
                              d="M1.618,1.341l0.195-0.196l4.621,4.586v0.403l-4.621,4.586l-0.404-0.405l4.383-4.383L1.408,1.55L1.618,1.341z"
                            />
                          </svg>
                        </span>
                      </Link>
                    </li>

                    <li id="menu-item-3069">
                      <Link to={"/track-order"}>
                        <span className="qodef-menu-item-text">
                          Track Order
                          <svg
                            className="qodef-menu-item-arrow"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="7.76px"
                            height="11.75px"
                            viewBox="0 0 7.76 11.75"
                            enableBackground="new 0 0 7.76 11.75"
                            xmlSpace="preserve"
                          >
                            <path
                              fill="#63605A"
                              d="M1.618,1.341l0.195-0.196l4.621,4.586v0.403l-4.621,4.586l-0.404-0.405l4.383-4.383L1.408,1.55L1.618,1.341z"
                            />
                          </svg>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </nav>
              </div>
              <a
                itemProp="url"
                className="qodef-header-logo-link qodef-height--set"
                href="/#"
                style={{ height: 92 }}
                rel="home"
              >
                <img
                  width={150}
                  height={71}
                  src={HeaderLogo}
                  className="qodef-header-logo-image qodef--main"
                  alt="logo main"
                  itemProp="image"
                />
              </a>
            </div>
          </div>
        </header>
        <header id="qodef-page-mobile-header" role="banner">
          <div id="qodef-page-mobile-header-inner" className="">
            <a
              itemProp="url"
              className="qodef-mobile-header-logo-link qodef-height--set"
              href="/#"
              style={{ height: 50, padding: "0px 0px 0px 0px" }}
              rel="home"
            >
              <img
                width={242}
                height={100}
                src={HeaderLogo}
                className="qodef-header-logo-image qodef--main"
                alt="logo main"
                itemProp="image"
              />
            </a>

            <a
              href="/#"
              className="qodef-opener-icon qodef-m qodef-source--predefined qodef-mobile-header-opener"
            >
              <span className="qodef-m-icon qodef--open">
                <span className="qodef-m-text">
                  <svg
                    className="qodef-m-svg-icon"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      strokeMiterlimit={10}
                      cx="34.334"
                      cy="34.334"
                      r="33.5"
                    />
                    <circle
                      strokeMiterlimit={10}
                      cx="34.334"
                      cy="34.334"
                      r="33.5"
                    />
                  </svg>
                  <List size={26} />
                </span>
              </span>
              <span className="qodef-m-icon qodef--close">
                <span className="qodef-m-text">
                  <svg
                    className="qodef-m-svg-icon"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      strokeMiterlimit={10}
                      cx="34.334"
                      cy="34.334"
                      r="33.5"
                    />
                    <circle
                      strokeMiterlimit={10}
                      cx="34.334"
                      cy="34.334"
                      r="33.5"
                    />
                  </svg>
                  <X size={26} />
                </span>
              </span>
            </a>
            <nav
              className="qodef-mobile-header-navigation"
              role="navigation"
              aria-label="Mobile Menu"
            >
              <ul id="menu-main-menu-2" className="qodef-content-grid">
                <Link to={"/"}>
                  <li>
                    <span className="qodef-menu-item-text">Home</span>
                  </li>
                </Link>
                <Link to={"/about-us"}>
                  <li>
                    <span className="qodef-menu-item-text">About Us</span>
                  </li>
                </Link>
                <Link to={"/products"}>
                  <li>
                    <span className="qodef-menu-item-text">Products</span>
                  </li>
                </Link>
                <Link to={"/contact-us"}>
                  <li>
                    <span className="qodef-menu-item-text">Contact Us</span>
                  </li>
                </Link>
                <Link to={"/track-order"}>
                  <li>
                    <span className="qodef-menu-item-text">
                      Track Your Order
                    </span>
                  </li>
                </Link>
              </ul>
            </nav>
          </div>
        </header>
      </>
    </>
  );
};

export default Header;
